// Libraries
var React = require('react');
var hdate = require('human-date');
var $ = require('jquery');

// Styles
require('./SearchResults.scss');

// Assets
var searchIcon = require('images/search-blue.svg');
var spinner = require('../../common/images/Rolling.svg');
var dateFormat = require('dateformat');

// Components
var VideoModule = require('Video/VideoModule');
var LoadMore = require('LoadMore/LoadMore');
var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');

class SearchResultsModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			results: this.props.data.searchResults.results,
			selectedOption: this.props.data.searchResults.sortOptions.find(x => x.selected === true).value,
			loadMoreUrl: this.props.data.searchResults.loadMoreLink,
			searchTerm: this.props.data.searchRequest.searchTerm,
			totalResults: this.props.data.searchResults.totalResults,
			sortOptions: this.props.data.searchResults.sortOptions,
			isLoadingResults: false,
			isLoadingMore: false,
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null
		}
	}

	search = (searchTerm) => {
		let url = this.props.data.searchResults.baseUrl + "?page=1&SearchTerm=" + searchTerm + "&SortOption=" + this.state.selectedOption;

		this.callAjax(url,
			(data) => {
				// done
				if (data.searchResults && data.searchResults.results && data.searchResults.results.length > 0) {
					this.setState({ results: data.searchResults.results, totalResults: data.searchResults.totalResults, sortOptions: data.searchResults.sortOptions, isLoadingResults: false, loadMoreUrl: data.searchResults.loadMoreLink }, window.LazyLoad.concat);
				} else {
					this.setState({ results: [], isLoadingResults: false, loadMoreUrl: null });
				}
			},
			(data) => {
				// error				
				this.setState({ results: [], isLoadingResults: false, loadMoreUrl: null });
			}
		);

		this.setState({ searchTerm: searchTerm });
	}

	callAjax = (url, done, fail) => {
		$.ajax({
			method: "GET",
			url: url
		})
			.done(data => {
				if (done) done(data);
			})
			.fail(data => {
				if (fail) fail(data);
			});
	}

	generatePlaceholder = (result) => {
		if (result.media && (result.media.type === 'VIDEO' || result.media.type === 'AUDIO')) {
			// we ignore what the BE send as videos should always be modal in search results
			result.media.displayType = 'MODAL';
			return <VideoModule data={result.media} hasAccess={true} publishedDate={result.date} />
		}

		if (result.image) {
			// this images doesn't use all the responsive sizes because it is relatively small
			// using the medium size for all devices and widths
			return <a href={result.url}><div className="SearchResults__image" data-bg={result.image.mediumUrl}></div></a>
		}

		return <a href={result.url}><div className="SearchResults__image"><p>{result.title}</p></div></a>
	}

	handleSubmit = (event) => {
		event.preventDefault();
		let searchTerm = this.searchInput.value;
		if (searchTerm.length > 0) {

			if (this.state.defaultMParticleEventObject !== null) {

				const eventData = {
					event: 'content_searched',
					search_keyword: searchTerm,
					search_type: 'site_search'
				};
	
				const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
	
				window.dataLayer.push(eventDataMerged);
	
			}

			// Push the new url to the browser history.
			if (typeof window.history !== "undefined") {
				window.history.pushState(null, "", "/search/?SearchTerm=" + searchTerm);
			}

			this.setState({ isLoadingResults: true });
			this.search(searchTerm);
		} else {
			this.setState({ results: [], loadMoreUrl: null });
		}
	}

	handleSelectChange = (event) => {
		this.setState({ selectedOption: event.target.key, isLoadingResults: true });

		this.callAjax(event.target[event.target.selectedIndex].dataset.url,
			(data) => {
				// done
				if (data.searchResults && data.searchResults.results && data.searchResults.results.length > 0) {
					this.setState({ results: data.searchResults.results, loadMoreUrl: data.searchResults.loadMoreLink, totalResults: data.searchResults.totalResults, sortOptions: data.searchResults.sortOptions, isLoadingResults: false }, window.LazyLoad.concat);
				}
			}, () => {
				// error
				this.setState({ results: [], isLoadingResults: false, loadMoreUrl: null });
			}
		);
	}

	handleLoadMore = (event) => {
		this.setState({ isLoadingMore: true });

		this.callAjax(this.state.loadMoreUrl.url,
			(data) => {
				// done
				if (data.searchResults && data.searchResults.results && data.searchResults.results.length > 0) {
					let visibleData = this.state.results.slice();
					this.setState({ results: visibleData.concat(data.searchResults.results), loadMoreUrl: data.searchResults.loadMoreLink, isLoadingMore: false }, window.LazyLoad.concat);
				}
			},
			() => {
				// fail
				this.setState({ isLoadingMore: false });
			}
		);
	}

	render() {
		return (
			<div className="SearchResults">
				<div className="SearchResults__container">
					<div className="SearchResults__input">
						<form onSubmit={this.handleSubmit}>
							<label htmlFor="searchResultInput">Search</label>
							<input id="searchResultInput" type="text" ref={(searchInput) => { this.searchInput = searchInput; }} name="SearchInput" placeholder="Search" defaultValue={this.props.data.searchRequest.searchTerm} />
							<button type="submit"><img src={searchIcon} alt="Submit search button" /></button>
						</form>
					</div>
					{this.state.results.length > 0 &&
						<div className="SearchResults__filter-wrapper">
							<h2>{this.state.totalResults} {this.state.results.length === 1 ? "result" : "results"} for {this.state.searchTerm}</h2>
							<div className="SearchResults__filter">
								<select value={this.state.selectedOption} onChange={this.handleSelectChange}>
									{this.state.sortOptions && this.state.sortOptions.map(function (item, index) {
										return (<option id={item.key} key={index} data-url={item.url}>{item.value}</option>);
									})}
								</select>
							</div>
						</div>
					}
					{!this.state.isLoadingResults && this.state.results.length > 0 && this.state.results.map((result, index) => (
							<div className="SearchResults__result" key={index} data-score={result.score}>
								<RestrictedComponent hasAccess={!result.hasOwnProperty('hasAccess') || result.hasAccess === true} isVideo={result.media && result.media.type === "VIDEO"}>
									<div className="SearchResults__result-wrapper">
										{this.generatePlaceholder(result)}
										<div className="SearchResults__content">
											{result.tags !== null &&
												<div className="SearchResults__tags">
													{result.tags !== null && result.tags.filter(tag => tag !== null).map((item, index) => {
														return (
															<a className="SearchResults__tag" rel="nofollow" href={item.url} key={index}>{item.hashtag}</a>
														);
													})}
												</div>
											}
											<h3 className="SearchResults__title">
											<a href={(result.media && result.media.externalLink) ? result.media.externalLink : result.url} target={(result.media && result.media.externalLink) ? "_blank" : "_self"} rel={(result.media && result.media.externalLink) ? "noreferrer noopener" : undefined}>{result.title}</a>
											</h3>
											{result.description &&
												<p className="SearchResults__description">{result.description.length > 100 ? (result.description.substring(0, 100) + "...") : result.description}</p>
											}

											{result.showDate ? (
												<span className="SearchResults__date" title={hdate.relativeTime(result.articleDate)}>{dateFormat(result.articleDate, "dd mmmm yyyy")} | {result.type}</span>
											) : (
													<span className="SearchResults__date">{result.type}</span>
												)}
										</div>
									</div>
								</RestrictedComponent>
							</div>
						)
					)}
					{this.state.results.length === 0 &&
						<p>No search results were found</p>
					}
					{!this.state.isLoadingMore && !this.state.isLoadingResults && this.state.loadMoreUrl &&
						<LoadMore handle={this.handleLoadMore} caption="Show more" context="search results"/>
					}
					{(this.state.isLoadingResults || this.state.isLoadingMore) &&
						<img src={spinner} className="spinner" alt="Loading animation" />
					}
				</div>
			</div>
		)
	}
}

module.exports = SearchResultsModule;



// WEBPACK FOOTER //
// ./src/components/SearchResults/SearchResultsModule.js